import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { openWhatsApp } from "@/lib/api";

export default function FinalCTA() {
  return (
    <section id="final-cta" className="relative py-20 md:py-28 bg-void overflow-hidden" data-testid="final-cta-section">
      <div
        className="absolute inset-0 pointer-events-none opacity-70"
        aria-hidden="true"
        style={{
          background:
            "radial-gradient(ellipse at 20% 20%, rgba(79,195,247,0.28), transparent 55%), radial-gradient(ellipse at 80% 80%, rgba(244,63,94,0.28), transparent 55%), radial-gradient(ellipse at 50% 50%, rgba(139,92,246,0.28), transparent 60%)",
        }}
      />
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 text-center relative">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8 }}
          className="eyebrow gradient-text"
        >
          You've found the car
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1.1, ease: [0.8, 0, 0.2, 1] }}
          className="mt-6 font-serif text-white text-6xl sm:text-7xl md:text-[8rem] leading-[0.9] tracking-tight"
        >
          Now let us <span className="italic gradient-text">fight for the deal.</span>
        </motion.h2>
        <motion.button
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.9 }}
          onClick={() => openWhatsApp({ source: "final_cta" })}
          className="mt-12 inline-flex items-center gap-3 px-8 py-5 rounded-full text-base md:text-lg font-medium text-white gradient-bg shadow-[0_25px_80px_-15px_rgba(139,92,246,0.7)] hover:scale-[1.03] transition-transform"
          data-testid="final-whatsapp-btn"
        >
          Talk to your Saarthi
          <ArrowRight className="w-5 h-5" />
        </motion.button>
        <p className="mt-6 text-silver/50 text-sm">You choose. We negotiate. You save. Start with ₹21.</p>
        <p className="mt-2 text-silver/35 text-xs">Written benchmark in 24 hours. Or your fee refunded.</p>
      </div>
    </section>
  );
}
